import React from 'react';

const Header = () => {
  const headerStyle = {
    padding: '20px 0 0',
    fontSize: '4.8rem',
    fontWeight: '600',
    color: '#ececec',
  };

  return (
    <header style={{ textAlign: 'center' }}>
      <h1 style={headerStyle}>
        Todos
      </h1>
      <p
        style={{
          fontSize: '1rem',
          fontWeight: '300',
          color: '#bdbdbe',
          margin: '1rem 0 2rem',
          fontFamily: 'cursive',
          lineHeight: 'inherit',
        }}
      >
        Items will persist in the browser Local Storage
      </p>
    </header>
  );
};

export default Header;
